(function () {
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        var _this = this;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        // eslint-disable-next-line no-console
        console.log(initialState);
        if (!Array.isArray(initialState) || initialState.length !== 4 || !initialState.every(function(row) {
            return Array.isArray(row) && row.length === 4 && row.every(function(cell) {
                return typeof cell === "number";
            });
        })) this.board = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        else this.board = initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        });
        this.board.forEach(function(el) {
            el.forEach(function(element) {
                if (element !== 0) _this.status = "playing";
            });
        });
        this.status = "idle";
        this.score = 0;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(i) {
                    var currentRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(_this.board[i]);
                    var proccesedRow = _this.proccesRow(_this.board[i]);
                    var isRowChanged = proccesedRow.some(function(val, index) {
                        return val !== currentRow[index];
                    });
                    if (isRowChanged) hasChanged = true;
                    _this.board[i] = proccesedRow;
                };
                var hasChanged = false;
                for(var i = 0; i < this.board.length; i++)_loop(i);
                if (hasChanged) {
                    this.setupRandomTile();
                    this.updateStatus();
                }
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(i) {
                    var rowBefore = (0, $227c6742e0ff6f82$export$71511d61b312f219)(_this.board[i]);
                    var reversed = (0, $227c6742e0ff6f82$export$71511d61b312f219)(_this.board[i]).reverse();
                    var proccesed = _this.proccesRow(reversed);
                    var finalRow = proccesed.reverse();
                    var isRowChanged = finalRow.some(function(val, index) {
                        return val !== rowBefore[index];
                    });
                    if (isRowChanged) hasChanged = true;
                    _this.board[i] = finalRow;
                };
                var hasChanged = false;
                for(var i = 0; i < this.board.length; i++)_loop(i);
                if (hasChanged) {
                    this.setupRandomTile();
                    this.updateStatus();
                }
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(col) {
                    var cloumn = [
                        _this.board[0][col],
                        _this.board[1][col],
                        _this.board[2][col],
                        _this.board[3][col]
                    ];
                    var proccesed = _this.proccesRow(cloumn);
                    var isColumnChanged = proccesed.some(function(val, index) {
                        return val !== cloumn[index];
                    });
                    if (isColumnChanged) hasChanged = true;
                    for(var row = 0; row < 4; row++)_this.board[row][col] = proccesed[row];
                };
                var hasChanged = false;
                for(var col = 0; col < 4; col++)_loop(col);
                if (hasChanged) {
                    this.setupRandomTile();
                    this.updateStatus();
                }
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(col) {
                    var cloumn = [
                        _this.board[0][col],
                        _this.board[1][col],
                        _this.board[2][col],
                        _this.board[3][col]
                    ];
                    var proccesed = _this.proccesRow((0, $227c6742e0ff6f82$export$71511d61b312f219)(cloumn).reverse());
                    var finalColumn = proccesed.reverse();
                    var isColumnChanged = finalColumn.some(function(val, index) {
                        return val !== cloumn[index];
                    });
                    if (isColumnChanged) hasChanged = true;
                    for(var row = 0; row < 4; row++)_this.board[row][col] = finalColumn[row];
                };
                var hasChanged = false;
                for(var col = 0; col < 4; col++)_loop(col);
                if (hasChanged) {
                    this.setupRandomTile();
                    this.updateStatus();
                }
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                if (this.status === "idle") {
                    this.status = "playing";
                    this.setupRandomTile();
                    this.setupRandomTile();
                }
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.board = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.score = 0;
                this.status = "idle";
                this.start();
            }
        },
        {
            key: "setupRandomTile",
            value: function setupRandomTile() {
                var emptyCells = [];
                this.board.forEach(function(r, rIndex) {
                    r.forEach(function(cell, cellIndex) {
                        if (cell === 0) emptyCells.push([
                            rIndex,
                            cellIndex
                        ]);
                    });
                });
                if (emptyCells.length === 0) return;
                var randomIndex = Math.floor(Math.random() * emptyCells.length);
                var _emptyCells_randomIndex = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCells[randomIndex], 2), row = _emptyCells_randomIndex[0], col = _emptyCells_randomIndex[1];
                var tileValue = Math.random() < 0.9 ? 2 : 4;
                this.board[row][col] = tileValue;
            }
        },
        {
            key: "proccesRow",
            value: function proccesRow(row) {
                var list = row.filter(function(x) {
                    return x !== 0;
                });
                for(var i = 0; i < list.length - 1; i++)if (list[i] === list[i + 1]) {
                    list[i] *= 2;
                    this.score += list[i];
                    list.splice(i + 1, 1);
                }
                while(list.length < 4)list.push(0);
                return list;
            }
        },
        {
            key: "updateStatus",
            value: function updateStatus() {
                var hasEmptyCells = false;
                var canMerge = false;
                for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
                    var current = this.board[r][c];
                    if (current === 2048) {
                        this.status = "win";
                        return;
                    }
                    if (current === 0) hasEmptyCells = true;
                    if (c < 3 && current === this.board[r][c + 1]) canMerge = true;
                    if (r < 3 && current === this.board[r + 1][c]) canMerge = true;
                }
                if (hasEmptyCells || canMerge) this.status = "playing";
                else this.status = "lose";
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$cells = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$startBtn = document.querySelector(".button");
var $197cd56b15c33885$var$scoreElement = document.querySelector(".game-score");
var $197cd56b15c33885$var$msgWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$msgLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$msgStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$previousState = null;
function $197cd56b15c33885$var$updateView() {
    var state = $197cd56b15c33885$var$game.getState();
    var score = $197cd56b15c33885$var$game.getScore();
    var GameStatus = $197cd56b15c33885$var$game.getStatus();
    $197cd56b15c33885$var$cells.forEach(function(cell, index) {
        var r = Math.floor(index / 4);
        var c = index % 4;
        var value = state[r][c];
        var prevValue = $197cd56b15c33885$var$previousState ? $197cd56b15c33885$var$previousState[r][c] : 0;
        cell.className = "field-cell";
        if (value > 0) {
            cell.textContent = value;
            cell.classList.add("field-cell--".concat(value));
            if (prevValue === 0) {
                cell.classList.add("tile-new");
                setTimeout(function() {
                    cell.classList.remove("tile-new");
                }, 180);
            }
            if (prevValue > 0 && value > prevValue) {
                cell.classList.add("tile-merged");
                setTimeout(function() {
                    cell.classList.remove("tile-merged");
                }, 180);
            }
        } else cell.textContent = "";
    });
    $197cd56b15c33885$var$previousState = state.map(function(row) {
        return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
    });
    $197cd56b15c33885$var$scoreElement.textContent = score;
    $197cd56b15c33885$var$msgWin.classList.add("hidden");
    $197cd56b15c33885$var$msgLose.classList.add("hidden");
    $197cd56b15c33885$var$msgStart.classList.add("hidden");
    if (GameStatus === "win") $197cd56b15c33885$var$msgWin.classList.remove("hidden");
    if (GameStatus === "lose") $197cd56b15c33885$var$msgLose.classList.remove("hidden");
    if (GameStatus === "idle") $197cd56b15c33885$var$msgStart.classList.remove("hidden");
    if (GameStatus !== "idle") {
        $197cd56b15c33885$var$startBtn.textContent = "Restart";
        $197cd56b15c33885$var$startBtn.classList.remove("start");
        $197cd56b15c33885$var$startBtn.classList.add("restart");
    }
}
$197cd56b15c33885$var$startBtn.addEventListener("click", function(events) {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") $197cd56b15c33885$var$game.start();
    else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$previousState = null;
    }
    $197cd56b15c33885$var$updateView();
});
document.addEventListener("keydown", function(events) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    // eslint-disable-next-line max-len
    var gameKeys = [
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "w",
        "a",
        "s",
        "d",
        "W",
        "A",
        "S",
        "D"
    ];
    if (!gameKeys.includes(events.key)) return;
    if (events.key === "ArrowLeft" || events.key.toLowerCase() === "a") $197cd56b15c33885$var$game.moveLeft();
    if (events.key === "ArrowRight" || events.key.toLowerCase() === "d") $197cd56b15c33885$var$game.moveRight();
    if (events.key === "ArrowUp" || events.key.toLowerCase() === "w") $197cd56b15c33885$var$game.moveUp();
    if (events.key === "ArrowDown" || events.key.toLowerCase() === "s") $197cd56b15c33885$var$game.moveDown();
    $197cd56b15c33885$var$updateView();
});

})();
//# sourceMappingURL=index.a7d33507.js.map
